import { constants } from '../../constants';
import { formatUtils, numericUtils } from '../../utils';

interface LoanPriceRangeProps {
    priceMin?: number;
    priceMax?: number;
}

export function LoanPriceRange({ priceMin, priceMax }: LoanPriceRangeProps) {
    if (priceMin == null && priceMax == null) return <>{constants.emptyPlaceholder}</>;

    const min = numericUtils.round((priceMin ?? priceMax)!, 3);
    const max = numericUtils.round((priceMax ?? priceMin)!, 3);

    return (
        <span>
            {min === max ? formatUtils.formatDecimal(min, 3) : `${Math.min(min, max)} - ${Math.max(min, max)}`}
        </span>
    )
}
